module.exports = "/images/vendor/flag-icon-css/flags/1x1/mh.svg?8f1f91348e69c8bf64d85e59272d6349";